<template>
    <div ref="top" class="trigger-management-new">
        <b-overlay :show="loading" :opacity="0.9" no-wrap>
        </b-overlay>
        <h3>Definições Gerais</h3>
        <div class="productionConfigs">
            <CustomInputRta :key="triggerProductions.processId" type="select" :blue-class="true" class="proc" id="proc"
                :modelRef="triggerProductions.processId" label="Processo" :optList="process" optValue="id"
                optDisplay="description" :inputFunc="event => {
                    this.triggerProductions.processId = Number(event.target.value)
                }" />

            <CustomInputRta :key="triggerProductions.productId" type="select" :blue-class="true" class="prod" id="prod"
                :modelRef="triggerProductions.productId" label="Produto" :optList="products" optValue="id"
                optDisplay="description" :inputFunc="event => {
                    this.triggerProductions.productId = Number(event.target.value)
                }" />

            <CustomInputRta :key="triggerProductions.equipmentId"  type="select" :blue-class="true" class="equip" id="equip"
                :modelRef="triggerProductions.equipmentId" label="Equipamento" :optList="equipment" optValue="id"
                optDisplay="description" :inputFunc="event => {
                    this.triggerProductions.equipmentId = Number(event.target.value)
                }" />
        </div>

        <h3>
            Gatilhos Indicadores Relacionados
            <b-icon class="question-icon-2" font-scale="0.9" icon="question-circle-fill"
                v-b-popover.hover="{ variant: 'secondary', content: this.$t('explicacao-rta-4'), }"></b-icon>
        </h3>

        <div class="exclusive-trigger">
            <div class="question-span">
                <div>
                    <span>
                        <b-form-checkbox v-model="RSG.active" @change="sendRSG"></b-form-checkbox>
                        Soma de FCAs Vinculadas
                        <b-icon class="question-icon" font-scale="0.9" icon="question-circle-fill"
                            v-b-popover.hover="{ variant: 'secondary', content: this.$t('explicacao-rta-1'), }"></b-icon>
                    </span>
                </div>
                <div>
                    <div>
                        <label for="sumFcaQtd">Quantidade:</label>
                        <input id="sumFcaQtd" type="number" v-model="RSG.maxQtd" @keyup="sendRSG" @change="sendRSG">
                    </div>
                    <div>
                        <label for="sumFcaTime">Tempo (dias):</label>
                        <input id="sumFcaTime" type="number" v-model="RSG.maxDays" @keyup="sendRSG" @change="sendRSG">
                    </div>
                </div>
            </div>
            <div>
                <span>
                    <b-form-checkbox v-model="RFG.active" @change="sendRFG"></b-form-checkbox>
                    Quantidade de FCAs
                    <b-icon class="question-icon" font-scale="0.9" icon="question-circle-fill"
                        v-b-popover.hover="{ variant: 'secondary', content: this.$t('explicacao-rta-2'), }"></b-icon>
                </span>
                <div>
                    <div>
                        <label for="geralFcaQtd">Quantidade:</label>
                        <input id="geralFcaQtd" type="number" v-model="RFG.maxQtd" @keyup="sendRFG" @change="sendRFG">
                    </div>
                    <div>
                        <label for="geralFcaTime">Tempo (dias):</label>
                        <input id="geralFcaTime" type="number" v-model="RFG.maxDays" @keyup="sendRFG" @change="sendRFG">
                    </div>
                </div>
            </div>
            <div>
                <span>
                    <b-form-checkbox v-model="RFI.active" @change="sendRFI"></b-form-checkbox>
                    FCAs de Indicador
                    <b-icon class="question-icon" font-scale="0.9" icon="question-circle-fill"
                        v-b-popover.hover="{ variant: 'secondary', content: this.$t('explicacao-rta-3'), }"></b-icon>
                </span>
                <div>
                    <div>
                        <label for="indFcaSelect">Indicador:</label>
                        <CustomInputRta type="select" :optList="indicatorsRelated" optValue="IndicatorId"
                            optDisplay="IndicatorName" :modelRef="RFI.indicatorId" :inputFunc="event => {
                                RFI.indicatorId = event.target.value
                            }" />
                    </div>
                    <div class="qtd-fca-ind">
                        <label for="indFcaQtd">Quantidade:</label>
                        <input id="indFcaQtd" type="number" v-model="RFI.maxQtd" @keyup="sendRFI" @change="sendRFI">
                    </div>
                    <div>
                        <label for="indFcaTime">Tempo (dias):</label>
                        <input id="indFcaTime" type="number" v-model="RFI.maxDays" @keyup="sendRFI()"
                            @change="sendRFI()">
                    </div>
                </div>
            </div>
        </div>

        <h3>
            Gatilhos Gerais
            <b-icon class="question-icon-2" font-scale="0.9" icon="question-circle-fill"
                v-b-popover.hover="{ variant: 'secondary', content: this.$t('explicacao-rta-5'), }"></b-icon>
        </h3>

        
        <TriggerLimitValue :triggerInfo="triggerInfo" :reset="resetForm" :show="showTriggerInDays" :isRta="true" />
        <TriggerReliability :triggerInfo="triggerInfo" :reset="resetForm" :show="showTriggerInDays" :isRta="true" />
        <TriggerAverageValue :triggerInfo="triggerInfo" :reset="resetForm" :show="showTriggerInDays" :isRta="true" />


        <b-row class="groupBtn">
            <img src="@/assets/cancel.png" :title="$t('limpar-formulario')" alt="limpar" @click="cleanFields" />
            <img src="@/assets/atualizar.png" :title="$t('recarregar-dados')" alt="recarregar"
                @click="loadConfigurations" />
            <img src="@/assets/salvar.png" alt="salvar" :title="$t('salvar')" @click="saveDataInDatabase(false)" />
        </b-row>

        <TriggerList :isRta="true" :deviationList="tableSet.collection || []" @saveTrigger="saveTriggers"
            @deleteTrigger="askDeleteTrigger" class="triggerListRta" />

        <b-modal id="AskDeleteTrigger" size="md" hide-footer :title="$t('alerta')" :no-close-on-backdrop="true">
            <MessageBox :question="deleteMessage" :action="deleteTrigger" modelname="AskDeleteTrigger" />
        </b-modal>
    </div>
</template>

<script>
import axios from 'axios';
import {
    urlMainAPI,
    defaultSuccess,
    ParseNumber,
    showError
} from '../../../global';
import { mapState } from 'vuex';
import TriggerLimitValue from "../../triggerManagement/template/TriggerValueLimit.vue";
import TriggerReliability from "../../triggerManagement/template/TriggerReliability.vue";
import TriggerAverageValue from "../../triggerManagement/template/TriggerAverageValue.vue";
import TriggerList from "../../triggerManagement/template/TriggerList.vue";
import MessageBox from "../../template/MessageBox.vue";
import MediatorTrigger from "../../triggerManagement/tools/MediatorTrigger";
import TriggerInfo from "../../triggerManagement/tools/triggerInfo";
import TriggerSet from "../../triggerManagement/model/TriggerSet";
import CustomInputRta from './CustomInputRta.vue';
import TriggerTableSet from "../../triggerManagement/model/TriggerTableSet";

export default {
    name: "TriggerManagementNew",
    components: {
        MessageBox,
        TriggerList,
        TriggerLimitValue,
        TriggerReliability,
        TriggerAverageValue,
        CustomInputRta,
    },
    props: ["indicator", "indicatorsRelated"],
    computed: mapState(["isOnlineReady"]),
    provide() {
        return {
            showInfo: this.showInfo,
            showResponsibles: this.showResponsibles
        }
    },
    data() {
        return {
            showTriggerInDays: true,
            loading: false,
            configuration: {},
            triggerInfo: null,
            triggerSet: {},
            tableSet: { collection: [] },
            loadTable: false,
            resetForm: 0,
            deleteMessage: "",
            process: [],
            products: [],
            equipment: [],
            triggerProductions: {
                processId: null,
                productId: null,
                equipmentId: null,
            },

            RFG: {
                active: false,
                maxQtd: 0,
                maxDays: 0
            },

            RSG: {
                active: false,
                maxQtd: 0,
                maxDays: 0
            },

            RFI: {
                active: false,
                indicatorId: 0,
                maxQtd: 0,
                maxDays: 0
            }

        }
    },

    watch: {
        // Quando mudar o processo selecionado, propaga para gatilhos ainda sem ID
        'triggerProductions.processId'(v) {
            if (this.triggerSet && Array.isArray(this.triggerSet.triggers)) {
            this.triggerSet.triggers.forEach(t => {
                if (!t.processId) t.processId = v;
            });
            }
        },

        // Propaga o produto
        'triggerProductions.productId'(v) {
            if (this.triggerSet && Array.isArray(this.triggerSet.triggers)) {
            this.triggerSet.triggers.forEach(t => {
                if (!t.productId) t.productId = v;
            });
            }
        },

        // Propaga o equipamento
        'triggerProductions.equipmentId'(v) {
            if (this.triggerSet && Array.isArray(this.triggerSet.triggers)) {
            this.triggerSet.triggers.forEach(t => {
                if (!t.equipmentId) t.equipmentId = v;
            });
            }
        },
    },

    methods: {
        scrollToTop() {
            this.$refs.top?.scrollIntoView({ behavior: 'smooth' });
        },
        
        loadForm(value) {
            if (!value.RFG) return
            this.loadData(value)
        },

        sendRFG() {
            MediatorTrigger.notify({
                active: this.RFG.active,
                maxQtd: this.RFG.maxQtd,
                maxDays: this.RFG.maxDays
            }, "setRFG")
        },

        sendRSG() {
            MediatorTrigger.notify({
                active: this.RSG.active,
                maxQtd: this.RSG.maxQtd,
                maxDays: this.RSG.maxDays
            }, "setRSG")
        },

        sendRFI() {
            MediatorTrigger.notify({
                active: this.RFI.active,
                maxQtd: this.RFI.maxQtd,
                maxDays: this.RFI.maxDays,
                indicatorId: this.RFI.indicatorId
            }, "setRFI")
        },

        loadData(value) {
            // garante que os selects recebam IDs vindos do item da lista
            if (typeof value.processId   === 'number') this.triggerProductions.processId   = value.processId;
            if (typeof value.productId   === 'number') this.triggerProductions.productId   = value.productId;
            if (typeof value.equipmentId === 'number') this.triggerProductions.equipmentId = value.equipmentId;

            //
            this.scrollToTop();

            this.RFG.active = value.RFG.active;
            if (value.RFG.configurationJSON) {
                let configurationJSON = JSON.parse(value.RFG.configurationJSON)
                this.RFG.maxDays = configurationJSON.maxDays;
                this.RFG.maxQtd = configurationJSON.maxQtd;
            }

            this.RSG.active = value.RSG.active;
            if (value.RSG.configurationJSON) {
                let configurationJSON = JSON.parse(value.RSG.configurationJSON)
                this.RSG.maxDays = configurationJSON.maxDays;
                this.RSG.maxQtd = configurationJSON.maxQtd;
            }

            this.RFI.active = value.RFI.active;
            if (value.RFI.configurationJSON) {
                let configurationJSON = JSON.parse(value.RFI.configurationJSON)
                this.RFI.maxDays = configurationJSON.maxDays;
                this.RFI.maxQtd = configurationJSON.maxQtd;
                this.RFI.indicatorId = configurationJSON.indicatorId;
            }

            this.$nextTick(() => {
                this.sendRFG();
                this.sendRSG();
                this.sendRFI();
            });

            Object.values(value).forEach(i => {
                if (typeof i.equipmentId == "number") this.triggerProductions.equipmentId = i.equipmentId;
                if (typeof i.productId == "number") this.triggerProductions.productId = i.productId;
                if (typeof i.processId == "number") this.triggerProductions.processId = i.processId;
            })

            if (!this.triggerProductions.processId && value.processId !== undefined)
            this.triggerProductions.processId = value.processId;

            if (!this.triggerProductions.productId && value.productId !== undefined)
            this.triggerProductions.productId = value.productId;
        
            if (!this.triggerProductions.equipmentId && value.equipmentId !== undefined)
            this.triggerProductions.equipmentId = value.equipmentId;
        },

        cleanFields(resetTriggers = true) {
            this.resetForm++;

            if (resetTriggers && this.triggerSet) {
                this.triggerSet.setNewTriggers();
            }

            if (resetTriggers) {
                this.triggerProductions = {
                processId: null,
                productId: null,
                equipmentId: null,
                };
            }

            this.RFG = { active: false, maxQtd: 0, maxDays: 0 };
            this.RSG = { active: false, maxQtd: 0, maxDays: 0 };
            this.RFI = { active: false, maxQtd: 0, maxDays: 0, indicatorId: null };

            defaultSuccess(this.$t('formulario-restaurado'));
        },

        async loadConfigurations() {
            this.loadTable = true;
            this.loading = true;
            await this.getDataFromDatabase();
            this.setInitialTrigger();
            await this.updateTableList();
            this.loading = false;
            this.loadTable = false;
        },

        async getDataFromDatabase() {
            try {
                const res = await axios.get(`${urlMainAPI}/getconfigurationsfortrigger`);
                if (res.status === 200) {
                    this.configuration = res.data;

                    this.process = res.data.process;
                    this.products = res.data.product;
                    this.equipment = res.data.equipment;

                    this.cleanFields();
                    this.triggerInfo = new TriggerInfo(res.data.triggersInfo);
                }
            } catch (error) {
                console.warn(error);
            }
        },

        async updateTableList() {
            this.loadTable = true;
            await axios.get(`${urlMainAPI}/gettriggers/${true}`)
                .then(res => {

                    console.log("Dados recebidos do backend:", res.data);
                    if (res.status == 200 && res.data.length > 0) {
                        let filtered = res.data.filter(i => i.indicatorId == this.indicator.MainIndicatorId);
                        console.log("Dados filtrados por indicador:", filtered);
                        this.tableSet = new TriggerTableSet(filtered);
                        this.triggerSet.setCollection(filtered);
                    } else {
                        this.tableSet = new TriggerTableSet([]);
                        this.triggerSet.setCollection([]);
                    }
                })
                .catch(console.warn)
            this.loadTable = false;
        },

        async saveDataInDatabase() {
            if (this.triggerProductions.processId == null) {
                this.$bvToast.toast("Selecione o processo antes de salvar.", {
                title: "Processo Obrigatório",
                variant: "warning",
                toaster: "b-toaster-bottom-left",
                solid: true,
                });
                return;
            }

            let triggers = this.tryGetTriggerToSave();
            if (!triggers.length) return;

            const rawList =
                this.triggerInfo?.triggersInfo ||
                this.configuration?.triggersInfo ||
                [];

            const codeIdMap = rawList.reduce((acc, t) => {
                acc[t.triggercode] = t.id;
                return acc;
            }, {});

            triggers = triggers.map((t) => {
                if (["ALD", "ADI", "VMD", "VFR"].includes(t.triggercode)) {
                t.triggercode = `${t.triggercode}_RTA`;
                }

                t.triggerId = codeIdMap[t.triggercode] || t.triggerId || 0;

                if (t.triggerId === 0) {
                showError(`TriggerId não encontrado para ${t.triggercode}.`);
                throw new Error("TriggerIdMissing");
                }
                return t;
            });

            triggers = triggers.map((t) => ({
                ...t,
                configurationJSON:
                // só força "{}" se o gatilho estiver ativo
                (!t.configurationJSON || t.configurationJSON.trim() === "")
                    ? (t.active ? "{}" : "")
                    : t.configurationJSON,
                equipment: "-",
                equipmentId: this.triggerProductions.equipmentId ?? 0,
                indicatorId: this.indicator.MainIndicatorId,
                indicatorName: "-",
                process: "-",
                processId: this.triggerProductions.processId ?? 0,
                product: "-",
                productId: this.triggerProductions.productId ?? 0,
                operatingRange: "-",
            }));

            triggers = triggers.filter(
                (t) => t.active || (t.configurationJSON && t.configurationJSON !== "")
            );
            if (!triggers.length) {
                showError(this.$t("e-necessario-selecionar-um-gatilho-para-salvar"));
                return;
            }

            const ok = await this.saveTriggers(triggers);

            if (ok) {
                defaultSuccess(this.$t("dados-do-gatilho-salvo-com-sucesso"));
                this.cleanFields();
                await this.loadConfigurations();
            }
        },

        tryGetTriggerToSave() {
            let triggers = [];

            try {
                triggers = this.triggerSet.getTriggersToSave();
            }
            catch (e) {
                showError(e);
                return [];
            }

            if (triggers.length === 0)
                showError(this.$t('e-necessario-selecionar-um-gatilho-para-salvar'));
            return triggers;
        },

        async saveTriggers(triggers) {
            this.loadTable = true;
            try {
                triggers.forEach(t => t.target = ParseNumber(t.target));

                const res = await axios.post(`${urlMainAPI}/savetriggers/${true}`, triggers);
                return res.status === 200;          
            } catch (err) {
                console.error(err);
                showError(this.$t('falha-ao-salvar-gatilho'));
                return false;                       
            } finally {
                this.loadTable = false;
            }
        },


        askDeleteTrigger(triggerItem) {
            this.deleteMessage = `${this.$t('deseja-apagar-o-gatilho')} [${triggerItem.indicator}]?`;
            this.deleteTrigger(triggerItem);
        },

        async deleteTrigger(triggerItem) {
            this.loadTable = true;
            try {
                const res = await axios.get(`${urlMainAPI}/deletetrigger/${triggerItem.key}`);
                if (res.status === 200) {
                    defaultSuccess(res.data);
                    await this.loadConfigurations();
                }
            } catch (error) {
                console.warn(error);
            }
            this.loadTable = false;
        },

        setInitialTrigger() {
            this.triggerInfo = new TriggerInfo(this.configuration.triggersInfo)
            this.triggerSet = new TriggerSet(this.triggerInfo)
        },
    },

    async created() {
        this.setInitialTrigger();
        await this.loadConfigurations()
        this.triggerSet.setNewTriggers({
            equipmentId: this.triggerProductions.equipmentId,
            indicatorKey: `${this.indicator.MainIndicatorId}-1-P`,
            processId: this.triggerProductions.processId,
            productId: this.triggerProductions.productId
        });
        MediatorTrigger.notify(this, "initRtaTriggers");
    }
};
</script>

<style scoped>
h3 {
    font-size: 1.5rem;
    display: flex;
    align-items: flex-end;
    column-gap: 0.3rem;
    white-space: nowrap;
    width: 100%;
    margin-top: 0.8rem;
}

h3::after {
    content: "";
    display: block;
    height: 1px;
    width: 100%;
    background-color: #d4d4d4;
}

.qtd-fca-ind {
    margin-left: 15px;
}

.productionConfigs {
    display: flex;
    align-items: center;
    justify-content: space-between;
    column-gap: 0.8rem;
    width: 100%;
}

.main-trigger {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 0.75rem;
}

.select-indicator {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.flex-row {
    display: flex;
}

.element-overlap>div>label {
    background: #ff5f00;
}

select,
label {
    margin: 0 !important;
}

select,
input {
    padding: 2px 8px;
    height: 23px;
    margin-left: 8px;
    font-size: 0.75rem;
    justify-content: center;
    align-items: center;
}

input {
    width: 60px;
    text-align: right;
}

.trigger-checkBox>input {
    margin-bottom: 5px;
}

.flex-space-between {
    justify-content: space-between;
}

.config-indicator {
    display: flex;
    justify-content: space-between;
}

.flex-column {
    margin-top: 5px;
    flex-direction: column;
    font-weight: 500;
}

.trigger-border {
    padding: 8px;
    border-radius: 4px;
    border: 1px solid #ff5f00;
    box-shadow: 0 0 2px #ff5f00;
}

.trigger-border>label {
    position: relative;
    padding: 0 3px;
    top: -23px;
    margin: 0;
    background-color: white;
    font-weight: 500;
}

.element-overlap {
    display: flex;
    position: relative;
    top: -23px;
}

.config-indicator>.trigger-border {
    min-width: 300px;
    max-width: 30%;
}

.justify-around {
    justify-content: space-around;
}

.set-values>span {
    display: flex;
    position: relative;
    top: -22px;
    height: 24px;
}

.set-values>.limit-value {
    min-width: 425px;
    width: 100%;
}

.img-width100 {
    display: flex;
    width: 100%;
    justify-content: center;
}

.width210 {
    min-width: 210px;
    max-width: 250px;
}

.width250 {
    min-width: 250px;
    max-width: 300px;
}

.width300 {
    width: 300px;
}

.width350 {
    width: 350px;
}

.width400 {
    width: 400px;
}

.question-icon {
    color: #ff5f00;
    cursor: pointer;
    position: relative;
    height: 13px;
    width: 24px;
    background: #fff;
    top: 1px;
}

.question-icon-2 {
    color: #ff5f00;
    cursor: pointer;
    position: relative;
    height: 13px;
    width: 15px;
    background: #fff;
    top: -15px;
}

.save-trigger {
    font-size: 1.8em;
    position: relative;
    top: 3px;
}

.trigger-icons {
    min-width: 60px;
}

.config-user {
    max-height: 21px;
    cursor: pointer;
    margin-left: 4px;
    color: #ff5f00;
}

.table-trigger,
.config-indicator,
.trigger {
    width: 100%;
    margin: 0;
}

.groupBtn {
    display: block;
    margin-left: auto;
    margin-right: 1rem;
}

.internal-config>span {
    width: 100%;
}

.trigger-box,
.set-values>.limit-value2,
.set-values>.limit-value,
.trigger-border>.internal-config {
    display: flex;
    margin-top: -12px;
    padding: 0 16px;
}

.set-values>.limit-value {
    padding: 0 8px;
}

.trigger-border>label {
    top: -19px;
}

.groupBtn img {
    cursor: pointer;
    max-height: 35px;
}

.disable-config {
    pointer-events: none;
    cursor: default;
    opacity: 40%;
}

.trigger {
    margin: 0 !important;
}

.trigger-management-new {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    row-gap: 1rem;
}

.exclusive-trigger {
    display: flex;
    align-items: center;
    justify-content: space-between;
    column-gap: 0.5rem;
    width: 100%;
}

.exclusive-trigger>div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0.5rem;
    height: 5rem;
    border: 2px solid #ffa672;
    border-radius: 0.2rem;
    position: relative;
}

.exclusive-trigger>div span {
    font-weight: 600;
    color: #ff5f00;
    position: absolute;
    font-size: 0.8rem;
    top: -13px;
    background-color: #fff;
    padding: 0.2rem;
    white-space: nowrap;
    display: flex;
    align-items: center;

}

.exclusive-trigger>div>div {
    display: flex;
    flex-direction: row;
    align-items: center;
    /* justify-content: space-between; */
    column-gap: 0.8rem;
}

.exclusive-trigger>div>div label {
    font-size: 0.9rem;
    font-weight: 500;
}

.exclusive-trigger>div>div input,
.exclusive-trigger>div>div select {
    width: 80%;
    height: 2rem;
    vertical-align: middle;
    border: 1px solid #C7C7C7 !important;
    border-radius: 0.2rem;
    margin: 0;
}

.exclusive-trigger select {
    padding: 0.3rem 0.5rem !important;
}

.groupBtn img {
    cursor: pointer;
    margin-left: 20px;
}

.triggerListRta {
    font-size: 0.8rem !important;
}
</style>